import { useNetworkOutage } from "~/composables/useNetworkOutage.js";
import { useEmployeeSession } from "~/stores/employeeSession.js";

export default defineNuxtPlugin(() => {
  const auth = useAuth();
  const employeeSession = useEmployeeSession();
  const runtimeConfig = useRuntimeConfig();
  const networkOutage = useNetworkOutage();

  const api = $fetch.create({
    baseURL: runtimeConfig.public.apiUrl + "/api/v1/terminal",
    onRequest({ options }) {
      if (!options.headers.has("Accept")) {
        options.headers.set("Accept", "application/json");
      }

      options.headers.set("Authorization", `Bearer ${auth.token}`);

      options.headers.set("Software-Version", runtimeConfig.public.appVersion);
      options.headers.set("Employee-Session", employeeSession.session?.id);

      networkOutage.attachHeaders(options.headers);
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await navigateTo("/login");
      }
    },
    onRequestError({ error }) {
      networkOutage.log();

      throw error;
    },
    onResponse({ response }) {
      networkOutage.clear();

      return response;
    },
  });

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api,
    },
  };
});
